import { GenericObjectDescription } from '../misc';

export interface AutocompleteInput {
  id?: number;
  name?: string;
  type?: string;
  inputValue?: string;
}

export interface PhysicianAutocompleteEntry extends AutocompleteInput {
  cbo: string | null;
  council_name: number | null;
  council_number: number | null;
  council_region: number | null;
}

export interface ClinicAutocompleteEntry extends AutocompleteInput {}

export interface ProcedureAutocompleteEntry extends GenericObjectDescription {
  price: string;
  tuss_procedure_id?: number | null;
}

export interface ProfessionCodeAutocompleteEntry extends AutocompleteInput {
  code: string | null;
  term: string;
}

export interface HiredSolicitantAutocompleteEntry extends AutocompleteInput {
  slug?: HiredSolicitantSlug;
  cbo?: number | null;
  council_name?: number | null;
  council_number?: number | null;
  council_region?: number | null;
}

export enum HiredSolicitantSlug {
  Physician = 'physician',
  Clinic = 'clinic',
}

export interface HiredSolicitantCodeEntry {
  id: number | string;
  type: HiredSolicitantSlug;
  code_type: string | null;
  code: string | null;
}

export interface Autocomplete {
  physicians: PhysicianAutocompleteEntry[];
  clinics: ClinicAutocompleteEntry[];
  procedures: ProcedureAutocompleteEntry[];
  hired_solicitants: HiredSolicitantCodeEntry[];
  versions: string[];
}
